import React, { useContext } from 'react';
import Button from '@bit/fabfitfun.shared.global.button';
import { SurveyPageContext } from '../context/SurveyPageContext';
import styles from './NavigationFooter.module.css';
import ButtonAction from '../../interfaces/buttonAction';

type OwnProps = {
  backButton: ButtonAction;
  nextButton: ButtonAction;
};

const NavigationFooter: React.FunctionComponent<OwnProps> = ({ backButton, nextButton }) => {
  const { surveyPage, firstBackButtonAction } = useContext(SurveyPageContext);

  const showBackButton = surveyPage !== 1 || firstBackButtonAction;
  const backButtonComponent = (
    <div className={styles.backButton}>
      <Button
        label={backButton.label}
        type="secondary"
        action="cancel"
        onClick={backButton.onClick}
        disabled={nextButton.disabled}
      />
    </div>
  );

  return (
    <div className={styles.navigationFooterContainer}>
      {showBackButton ? backButtonComponent : ''}
      <div className={styles.nextButton}>
        <Button
          label={nextButton.label}
          onClick={nextButton.onClick}
          disabled={nextButton.disabled}
        />
      </div>
    </div>
  );
};

NavigationFooter.displayName = 'NavigationFooter';

export default NavigationFooter;
